var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style["m-story"] }, [
    _c("div", [
      _c("div", { class: _vm.$style["m-bg"] }, [
        _c("video", {
          ref: "video",
          attrs: {
            preload: "auto",
            autoplay: "",
            muted: "",
            playsinline: "",
            src: require("@/assets/images/video/story-bg.mp4")
          },
          domProps: { muted: true }
        })
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "m-container", class: _vm.$style["m-container"] },
      [
        _c("div", { class: _vm.$style["container-inner"] }, [
          _c(
            "div",
            {
              staticClass: "flex justify-center",
              class: _vm.$style["module-head"]
            },
            [
              _c("div", { class: _vm.$style["module-info"] }, [
                _c(
                  "h2",
                  {
                    staticClass: "enter-animate animate__fadeInUp",
                    class: _vm.$style["module-title"]
                  },
                  [
                    _c("span", { staticClass: "text" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("400003")) +
                          "\n                        "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    staticClass: "enter-animate animate__fadeInUp",
                    class: _vm.$style["module-subtitle"]
                  },
                  [
                    _c("span", { staticClass: "text" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("400004")) +
                          "\n                        "
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style["module-body"] }, [
            _c(
              "div",
              {
                ref: "swiperDom",
                staticClass: "swiper enter-animate animate__fadeInUp",
                class: _vm.$style["swiper"]
              },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  [
                    _vm._l(_vm.storyList, function(item, index) {
                      return [
                        _c(
                          "div",
                          {
                            key: index + "-group1",
                            staticClass: "swiper-slide grid-flow-col-dense",
                            class: _vm.$style["list-item"]
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "inline-grid",
                                class: _vm.$style["item-group1"]
                              },
                              _vm._l(item.group1, function(img, i) {
                                return _c(
                                  "div",
                                  { key: i, class: _vm.$style["image-box"] },
                                  [_c("img", { attrs: { src: img } })]
                                )
                              }),
                              0
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            key: index + "-group2",
                            staticClass: "swiper-slide grid-flow-col-dense",
                            class: _vm.$style["list-item"]
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "inline-grid",
                                class: _vm.$style["item-group2"]
                              },
                              _vm._l(item.group2, function(img, i) {
                                return _c(
                                  "div",
                                  { key: i, class: _vm.$style["image-box"] },
                                  [_c("img", { attrs: { src: img } })]
                                )
                              }),
                              0
                            )
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex justify-center",
                class: _vm.$style["swiper-nav"]
              },
              [
                _c(
                  "div",
                  { staticClass: "items-center grid grid-cols-2 gap-3" },
                  [
                    _c(
                      "button",
                      {
                        ref: "prevBtn",
                        staticClass: "flex justify-center items-center",
                        class: _vm.$style["btn--swiper-prev"]
                      },
                      [
                        _c("UeIcon", {
                          class: { mirrorRotateLevel: _vm.isDirection },
                          attrs: { name: "long-arrow-left" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        ref: "nextBtn",
                        staticClass: "flex justify-center items-center",
                        class: _vm.$style["btn--swiper-next"]
                      },
                      [
                        _c("UeIcon", {
                          class: { mirrorRotateLevel: _vm.isDirection },
                          attrs: { name: "long-arrow-right" }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ae8a50a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae8a50a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/index/StoryModule.vue
// module id = HqZC
// module chunks = 0